import React from 'react';
import XYAxis from '../XYAxis/XYAxis.jsx';
import ChartLine from '../ChartLine/ChartLine.jsx';
import HighlightPoints from '../HighlightPoints/HighlightPoints.jsx';
import d3 from 'd3';

const xMax   = (data)  => d3.max(data, (d) => d3.max(d.series, (c) => c[0]));
const xMin   = (data)  => d3.min(data, (d) => d3.min(d.series, (c) => c[0]));
const yMax   = (data)  => d3.max(data, (d) => d3.max(d.series, (c) => c[1]));
const yMin   = (data)  => d3.min(data, (d) => d3.min(d.series, (c) => c[1]));
const xScale = (props) => {
  
  let xmin = Math.min(xMin(props.data),d3.min(props.xTicks));
  let xmax = Math.max(xMax(props.data),d3.max(props.xTicks));
  
  if(Object.prototype.toString.call(xmin) === '[object Date]') {
    return d3.time.scale()
    .domain([xmin, xmax])
    .range([props.paddingLeft, props.width - props.paddingRight]);    
  }
  return d3.scale.linear()
    .domain([xmin, xmax])
    .range([props.paddingLeft, props.width - props.paddingRight]);
};
const yScale = (props) => {
  let ymin = Math.min(yMin(props.data),d3.min(props.yTicks));
  let ymax = Math.max(yMax(props.data),d3.max(props.yTicks));
  if(Object.prototype.toString.call(ymin) === '[object Date]') {
    return d3.time.scale()
    .domain([ymin, ymax])
    .range([props.height - props.paddingBottom, props.paddingTop]);    
  }
  return d3.scale.linear()
    .domain([ymin, ymax])
    .range([props.height - props.paddingBottom, props.paddingTop]);
};
const marshalProps = (props) => {
  const scales = { xScale: xScale(props), yScale: yScale(props) };
  return Object.assign({}, props, scales);
};


export default (props) => {
    const d3Props = marshalProps(props);
    return <g>
        <XYAxis {...d3Props}/>
        {props.data.map(series => <ChartLine {...d3Props} dataseries={series} key={"chartline_"+series.name} />)}
        <HighlightPoints {...d3Props} closeness={30} onHighlight = {props.onHighlight} />
    </g>    
}



// WEBPACK FOOTER //
// ./src/js/components/charting/LineChartChart/LineChartChart.jsx